import React from 'react';
import Modal from 'react-modal';
import { IoMdCloseCircleOutline } from "react-icons/io";
import ScrollAnimation from 'react-animate-on-scroll';
import Slider from "react-slick";
import 'animate.css';

function CustomGallery({myGallery}) {

    //console.log(myGallery);

    const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
    };

    return (
        myGallery ?
            <section className="mb-16">
                <div className="container mx-auto text-center mt-12">
                    {/*<ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 m-auto rounded-2xl">Галерея</h6></ScrollAnimation>*/}
                    <ScrollAnimation animateIn="animate__fadeInUp"><h2 className="sm:text-4xl text-2xl mb-4 uppercase title-design before:bg-[#AF00A9]/30 after:bg-[#AF00A9]/30 w-full max-w-max mx-auto">{myGallery.gallery_title}</h2></ScrollAnimation>
                </div>
                <div className="grid  grid-cols-2 py-6  lg:grid-cols-4">
                    {
                        myGallery.gallery_item.map((item, index) => (
                            <a href="#" onClick={openModal} className="overflow-hidden" key={index}>
                                <img src={item} alt="img" className="hover:scale-110 transition duration-300"/>
                            </a>
                        ))
                    }
                </div>

                <Modal isOpen={modalIsOpen} onRequestClose={closeModal} ariaHideApp={false}>
                    <button onClick={closeModal} className="absolute top-2 right-2 z-[999]"><IoMdCloseCircleOutline className="text-red-800 text-4xl z-60" /></button>
                    <Slider {...settings}>
                        {
                            myGallery.gallery_item.map((item, index) => (
                                <img src={item} alt="img" key={index} />
                            ))
                        }
                    </Slider>
                </Modal>

            </section> : ''
    )

}

export default CustomGallery;